import { Box, IconButton } from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import { RiDeleteBinLine, RiFileEditLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import { deleteSubjectAssistPhoneRequest } from "../../../modules/admin-modules/subject-assist-phones/Actions";
import { openCreateSubjectAssistPhone } from "../../../modules/admin-modules/models/Actions";

const C = {
  primary: "#6A1E1E",
  secondary: "#4A0F1F",
  border: "#D8CEC3",
};

const iconBtnProps = {
  variant: "ghost",
  border: "0",
  size: "sm",
  color: C.primary,
  _hover: { bg: "rgba(106, 30, 30, 0.08)", color: C.secondary },
};

const typeLabel = (t) => {
  if (t === 1 || t === "1") return "Secretarial";
  if (t === 2 || t === "2") return "Academic";
  return "—";
};

const SubjectAssistPhonesTable = ({ setAdd, setSelectedData, searchTerm = "" }) => {
  const subjectAssistPhones = useSelector(
    (state) => state.subjectAssistPhones.subjectAssistPhones
  );
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.subjectAssistPhones.isLoading);
  const [, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);

  const list = useMemo(() => {
    const raw = Array.isArray(subjectAssistPhones) ? subjectAssistPhones : [];
    const q = (searchTerm || "").trim().toLowerCase();
    if (!q) return raw;
    return raw.filter((row) => {
      const phone = String(row?.phone ?? "").toLowerCase();
      const typ = typeLabel(row?.type).toLowerCase();
      return phone.includes(q) || typ.includes(q);
    });
  }, [subjectAssistPhones, searchTerm]);

  useEffect(() => {
    setPageNumber(0);
  }, [searchTerm]);

  const viewData = (row) => {
    const plain = list.find((r) => r.id === row?.id) ?? row;
    setSelectedData(plain);
    setAdd(false);
    dispatch(openCreateSubjectAssistPhone());
  };

  const Data = list.map((data) => ({
    ...data,
    id: data?.id,
    phone: data?.phone,
    type: typeLabel(data?.type),
    edit: (
      <IconButton
        {...iconBtnProps}
        aria-label="Edit phone line"
        fontSize="20px"
        icon={<RiFileEditLine />}
        onClick={(e) => {
          e.stopPropagation();
          setSelectedData(data);
          setAdd(false);
          dispatch(openCreateSubjectAssistPhone());
        }}
      />
    ),
    delete: (
      <IconButton
        {...iconBtnProps}
        aria-label="Delete phone line"
        fontSize="20px"
        icon={<RiDeleteBinLine color="#9b2c2c" />}
        onClick={(e) => {
          e.stopPropagation();
          dispatch(deleteSubjectAssistPhoneRequest(data?.id));
        }}
      />
    ),
  }));

  const columns = [
    { Header: "Phone", accessor: "phone" },
    { Header: "Type", accessor: "type" },
    { Header: "Edit", accessor: "edit" },
    { Header: "Delete", accessor: "delete" },
  ];

  const totalPage = Math.max(1, Math.ceil(list.length / size));

  return (
    <Box px={{ base: 4, md: 8 }} pb={10} w="100%">
      <Box
        bg="rgba(255,255,255,0.9)"
        border="1px solid"
        borderColor={C.border}
        borderRadius="16px"
        overflow="hidden"
        boxShadow="sm"
      >
        <CTable
          selectedData={viewData}
          Columns={columns}
          Data={Data}
          path="openModel"
          Title=""
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar
          noFilter
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar
          isLoading={isLoading}
          perPage={size}
          totalPage={totalPage}
          wrapperProps={{ maxH: "unset", overflow: "auto" }}
          tableProps={{ bg: "transparent", borderRadius: "0", mb: 0 }}
          theadProps={{ bg: "#D8CEC3", color: "#4A0F1F" }}
        />
      </Box>
    </Box>
  );
};

export default SubjectAssistPhonesTable;
